'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$32() {
  this.bhY = null;
  this.bhW = null;
  this.bhX = false;
  this.bhU = null;
  this.bhV = false;
  this.bhZ = false;
  this.bi0 = false;
  this.bhY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$32 as $c_Lpresto_PrestoRouter$$anon$32 };
$p = $c_Lpresto_PrestoRouter$$anon$32.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$32;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$32() {
}
export { $h_Lpresto_PrestoRouter$$anon$32 as $h_Lpresto_PrestoRouter$$anon$32 };
$h_Lpresto_PrestoRouter$$anon$32.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bhY;
});
$p.t = (function() {
  if ((!this.bhX)) {
    this.bhW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bhX = true;
  }
  return this.bhW;
});
$p.ag = (function() {
  if ((!this.bhV)) {
    this.bhU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bhV = true;
  }
  return this.bhU;
});
$p.v = (function() {
  if ((!this.bi0)) {
    this.bhZ = false;
    this.bi0 = true;
  }
  return this.bhZ;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$32 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$32, "presto.PrestoRouter$$anon$32", ({
  O6: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$32 as $d_Lpresto_PrestoRouter$$anon$32 };
//# sourceMappingURL=presto.-Presto-Router$$anon$32.js.map
